import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from 'react';
import cls from 'classnames';
import Button from '../Button/Button';
import FancyPopup from '../FancyPopup/FancyPopup';
import styles from './FancyDropdownButton.module.less';
/** @example
 * const [isOpened, setIsOpen] = useState(false);
 *
 * <FancyDropdownButton
 *   isOpen={isOpened}
 *   onChangeState={setIsOpen}
 *   label="New"
 *   size="m"
 *   {...otherButtonProps}
 * >
 *   <MenuList>
 *     <MenuItem onClick={() => {}}>
 *       Option 1
 *     </MenuItem>
 *
 *     <MenuItem onClick={() => {}}>
 *       Option 2
 *     </MenuItem>
 *   </MenuList>
 * </FancyDropdownButton>
 */
function FancyDropdownButton(props) {
    const { disabled, children, label, withTriangle, isOpen, onChangeState, placement, strategy, usePortal, popupClassName, onClickOutside, ...rest } = props;
    const [isOpened, setIsOpen] = useState(false);
    const isOpenState = typeof isOpen === 'boolean' ? isOpen : isOpened;
    function onChangeStateHandler(state) {
        if (typeof onChangeState === 'function') {
            onChangeState(state);
        }
        else {
            setIsOpen(state);
        }
    }
    const btn = (_jsxs(Button, { disabled: disabled, ...rest, children: [label, withTriangle && _jsx("span", { className: cls(styles.dropdownTriangle, { [styles.dropdownTriangleOpened]: isOpened }) })] }));
    if (disabled) {
        return btn;
    }
    return (_jsx(FancyPopup, { action: "click", trigger: btn, body: children, placement: placement, strategy: strategy, usePortal: usePortal, isOpen: isOpenState, onChangeState: onChangeStateHandler, onClickOutside: onClickOutside, className: cls(styles.content, popupClassName) }));
}
export default memo(FancyDropdownButton);
